export enum SlackChannels {
  DEBUG = 'debug', // not user, for unit testing only
  OPS_ERRORS = 'ops-errors',
  OPS_PAYMENT = 'ops-payment',
  // OPS_APP = 'ops-app', // not used yet
  OPS_SENDGRID = 'ops-sendgrid',
  OPS_POSTMARK = 'ops-postmark',
  OPS_NEWCUSTOMER = 'ops-newcustomer',
  OPS_SWISH = 'ops-swish',
  OPS_COMMUNICATION_SENDOUT = 'ops-communication-sendout',
  OPS_SMS = 'ops-sms',
  OPS_PAYMENT_REMINDER = 'ops-payment-reminder',
  OPS_MOBILE_AUTH_ERRORS = 'ops-mobile-auth-errors',
  OPS_FORTNOX = 'ops-fortnox',
  OPS_SEB_TRANSACTIONS = 'ops-seb-transactions',
  OPS_BROKEN_LINKS = 'C0ATJCV380Y'
}
